var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBuilding, faDownload, faEdit, faPlay, faSpinner, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import axios from "axios";
import { computed, ref, watch } from "vue";
import { fromSimple } from "@/components/Workflow/Editor/modules/model";
import { useDatatypesMapper } from "@/composables/datatypesMapper";
import { usePanels } from "@/composables/usePanels";
import { provideScopedWorkflowStores } from "@/composables/workflowStores";
import { useUserStore } from "@/stores/userStore";
import { assertDefined } from "@/utils/assertions";
import { withPrefix } from "@/utils/redirect";
import WorkflowInformation from "./WorkflowInformation.vue";
import ActivityBar from "@/components/ActivityBar/ActivityBar.vue";
import Heading from "@/components/Common/Heading.vue";
import FlexPanel from "@/components/Panels/FlexPanel.vue";
import ToolPanel from "@/components/Panels/ToolPanel.vue";
import WorkflowGraph from "@/components/Workflow/Editor/WorkflowGraph.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowPublished',
    props: {
        id: {
            type: String,
            required: true,
        },
        zoom: {
            type: Number,
            default: 0.75,
        },
        embed: {
            type: Boolean,
            default: false,
        },
        showButtons: {
            type: Boolean,
            default: true,
        },
        showAbout: {
            type: Boolean,
            default: true,
        },
        showHeading: {
            type: Boolean,
            default: true,
        },
        showMinimap: {
            type: Boolean,
            default: true,
        },
        showZoomControls: {
            type: Boolean,
            default: true,
        },
        initialX: {
            type: Number,
            default: -20,
        },
        initialY: {
            type: Number,
            default: -20,
        },
    },
    setup(__props) {
        const props = __props;
        library.add(faSpinner, faUser, faBuilding, faPlay, faEdit, faDownload);
        const workflowInfo = ref();
        const workflow = ref(null);
        const loading = ref(true);
        const errored = ref(false);
        const errorMessage = ref("");
        const { datatypesMapper } = useDatatypesMapper();
        const { stateStore } = provideScopedWorkflowStores(props.id);
        watch(() => props.zoom, () => (stateStore.scale = props.zoom), { immediate: true });
        watch(() => props.id, (id) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            workflowInfo.value = undefined;
            loading.value = true;
            errored.value = false;
            errorMessage.value = "";
            try {
                const [{ data: workflowInfoData }, { data: fullWorkflow }] = yield Promise.all([
                    axios.get(withPrefix(`/api/workflows/${id}`)),
                    axios.get(withPrefix(`/workflow/load_workflow?_=true&id=${id}`)),
                ]);
                assertDefined(workflowInfoData.name);
                workflowInfo.value = workflowInfoData;
                workflow.value = fullWorkflow;
                fromSimple(props.id, fullWorkflow);
            }
            catch (e) {
                const error = e;
                if ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data.err_msg) {
                    errorMessage.value = error.response.data.err_msg;
                }
                errored.value = true;
            }
            finally {
                loading.value = false;
            }
        }), {
            immediate: true,
        });
        const { showActivityBar, showToolbox } = usePanels();
        const downloadUrl = computed(() => withPrefix(`/api/workflows/${props.id}/download?format=json-download`));
        const importUrl = computed(() => withPrefix(`/workflow/imp?id=${props.id}`));
        const runUrl = computed(() => withPrefix(`/workflows/run?id=${props.id}`));
        const userStore = useUserStore();
        function logInTitle(title) {
            if (userStore.isAnonymous) {
                return `Log in to ${title}`;
            }
            else {
                return title;
            }
        }
        const initialPosition = computed(() => ({
            x: -props.initialX * props.zoom,
            y: -props.initialY * props.zoom,
        }));
        const viewUrl = computed(() => withPrefix(`/published/workflow?id=${props.id}`));
        return { __sfc: true, props, workflowInfo, workflow, loading, errored, errorMessage, datatypesMapper, stateStore, showActivityBar, showToolbox, downloadUrl, importUrl, runUrl, userStore, logInTitle, initialPosition, viewUrl, FontAwesomeIcon, WorkflowInformation, ActivityBar, Heading, FlexPanel, ToolPanel, WorkflowGraph };
    }
});
